import ConfigEkskul from "../../../../../components/categories/siakad/lms/data_ekskul/subpage/config_ekskul/Home";
export default function Home() {
  
  return (
    <ConfigEkskul />
  );
}
